export const LOCAL_STORAGE_AMOUNT_KEY = 'offerAmountState';
export const ORIGIN_URL = 'https://www.vivus.se';
export const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL;
export const COLA_URL = process.env.REACT_APP_COLA_URL as string;
export const APP_ENV = process.env.REACT_APP_ENV as string;

export const TERMS_AND_CONDITIONS_URL =
  'https://www.vivus.se/laanevilkor/lanevilkor';

export const R = {
  AffiliateProvider: '/affiliate/:provider',
  FirstLoanRegister: '/first-loan/register',
  FirstLoanWelcomeBack: '/first-loan/welcome-back',
  FirstLoanQuestionnaire: '/first-loan/questionnaire',
  FirstLoanIdentificationMethod: '/first-loan/identification-method',
  FirstLoanTink: '/first-loan/tink',
  FirstLoanTinkLoading: '/first-loan/tink-loading',
  FirstLoanPendingManual: '/first-loan/pending-manual',
  FirstLoanApprovedManual: '/first-loan/approved-manual',
  FirstLoanRejected: '/first-loan/rejected',
  FirstLoanApprovedTink: '/first-loan/approved-tink',
  FirstLoanRejectedTink: '/first-loan/rejected-tink',
  FirstLoanFdfApplied: '/first-loan/fdf-applied',
  FirstLoanCancelled: '/first-loan/cancelled',
  login: '/login',
  twoFA: '/login/2fa',
};
